<template>
  <div id="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
      {{ $t("basePage.title") }}
    </div>

    <div
      :class="{ 'fanyi-service': true, isActive: active }"
      :style="{ height: height1 }"
    >
      <div class="fanyi-service-left">
        <div class="item1">
          <img class="offline-img" :src="offlineImage" alt="" />
          {{ $t("basePage.title") }}
        </div>
        <div class="item2">{{ $t("basePage.function") }}</div>
      </div>
      <div class="fanyi-service-right">
        <div>
          <img
            class="scan-img"
            :src="scanImage"
            alt=""
            :style="{ marginTop: marginTop }"
          />
        </div>
      </div>
    </div>

    <div
      v-for="item in list"
      :key="item.id"
      :class="{ 'product-list': true, isChecked: item.checked }"
      @click="handleCheck(item)"
    >
      <div class="sale" v-if="item.checked && item.showDisCount">
        {{ item.discount }} {{ $t("basePage.sale") }}
      </div>
      <div class="checked" v-if="item.checked">
        <img class="checked-img" :src="checkedImg" alt="" />
      </div>
      <div class="product-left">
        {{ getTime(item.timeLimit) }}
        <span class="product-tip">
          ({{ $t("basePage.RMB") }}{{ item.unitPrice }}/{{
            $t("basePage.month")
          }}）
        </span>
      </div>
      <div class="product-right">{{ $t("basePage.RMB") }}{{ item.price }}</div>
    </div>

    <div class="describe">
      <div class="subscribe">{{ $t("basePage.describe") }}</div>
      <div class="subscribe-content">
        <div>
          {{ $t("basePage.describe1") }}
        </div>
        <div>{{ $t("basePage.describe2") }}</div>
      </div>
    </div>


    <div>
      <el-button class="pay-button" @click="handleConfirm">{{
        $t("OffLinePage.confirm")
      }}</el-button>
    </div>

    <div class="message" v-if="show">
      <div class="tip">{{ message }}</div>
    </div>

    <div class="drawer">
      <el-drawer
        :title="$t('OffLinePage.payType')"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        size="90%"
        :wrapperClosable="false"
      >
        <div style="padding-bottom:90px">
          <form id="payment-form" @submit.prevent="handleSubmit">
            <div id="payment-element" />
            <div id="card-errors" class="error" role="alert"></div>
            <button id="submit" class="pay-button" :disabled="isLoading">
              {{ $t("OffLinePage.confirm")
              }}<span>¥{{ amount }}</span>
            </button>
          </form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
  
  <script>
import { getGoods, getOrder } from "@/api/login/user";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "basePage",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      messages:[],
      publishableKey: "",
      isLoading: false,
      marginTop: "25px",
      height1: "88px",
      card: "",
      term: "",
      safetyCode: "",
      name: "",
      lang: "cn",
      drawer: false,
      direction: "btt",
      show: false,
      message: "",
      amount: 0,
      isCard: false,
      isWx: false,
      isGoogle: false,
      countNumber: 1,
      price: 298.88,
      active: false,
      queryParams: "",
      env: process.env.VUE_APP_BASE_API,
      closeImage: require("@/assets/close.png"),
      offlineImage: require("@/assets/base.png"),
      scanImage: require("@/assets/scan.png"),
      cardImage: require("@/assets/card.png"),
      wxImage: require("@/assets/wx.png"),
      googleImage: require("@/assets/google-pay.png"),
      checkedImg: require("@/assets/gou.png"),
      list1: [
        {
          id: 1,
          time: "1个月",
          price: "19",
          totalPrice: "19",
        },
        {
          id: 2,
          time: "半年",
          price: "17.56",
          totalPrice: "165",
        },
        {
          id: 3,
          time: "1年",
          price: "15.77",
          totalPrice: "300",
        },
      ],
      list: [],
      productId:'',
      orderNumber:''
    };
  },
  watch: {
    lang(val) {
      this.lang = val;
      this.getStyle();
    },
  },
  async mounted() {
    if(localStorage.getItem("lang") ==='cn'){
      this.setLanguage()
    }
    this.lang = localStorage.getItem("lang");
    this.getGoodsNet();
  },
  methods: {
    setLanguage() {
      let language = this.getPreferredLanguage();
      
      if (language.startsWith("zh")) {
        localStorage.setItem("lang", "cn");
        this.$i18n.locale = "cn";
        return
      }
      if(language.startsWith("en")){
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return
      }
      if (language.startsWith("ja")) {
        localStorage.setItem("lang", "ja");
        this.$i18n.locale = "ja";
        return
      }
      if (language.startsWith("ko")) {
        localStorage.setItem("lang", "ko");
        this.$i18n.locale = "ko";
        return
      }
      if (language.startsWith("ru")) {
        localStorage.setItem("lang", "ru");
        this.$i18n.locale = "ru";
        return
      }
      if (language.startsWith("es")) {
        localStorage.setItem("lang", "es");
        this.$i18n.locale = "es";
        return
      }
      if (language.startsWith("fr")) {
        localStorage.setItem("lang", "fr");
        this.$i18n.locale = "fr";
        return
      }
      if (language.startsWith("de")) {
        localStorage.setItem("lang", "de");
        this.$i18n.locale = "de";
        return
      }
      if (language.startsWith("pt")) {
        localStorage.setItem("lang", "pt");
        this.$i18n.locale = "pt";
        return
      }
      if (language.startsWith("it")) {
        localStorage.setItem("lang", "it");
        this.$i18n.locale = "it";
        return
      }
      if (language.startsWith("tr")) {
        localStorage.setItem("lang", "tr");
        this.$i18n.locale = "tr";
        return
      }
      if (language.startsWith("vi")) {
        localStorage.setItem("lang", "vi");
        this.$i18n.locale = "vi";
        return
      }
      if (language.startsWith("id")) {
        localStorage.setItem("lang", "id");
        this.$i18n.locale = "id";
        return
      }
      if (language.startsWith("hi")) {
        localStorage.setItem("lang", "hi");
        this.$i18n.locale = "hi";
        return
      }
      if (language.startsWith("ar")) {
        localStorage.setItem("lang", "ar");
        this.$i18n.locale = "ar";
        return
      }
      if (language.startsWith("th")) {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
        return
      }
      
    },
    getPreferredLanguage(){
      return navigator.language || navigator.userLanguage;
    },
    async getOrderNet() {
      const data = {
        code: "",
        payType: "stripe",
        productId: this.productId,
        types: "onetime",
        count: 1,
        orderType:'exchange'
      };
      await getOrder(data).then(async(res) => {
        this.clientSecret = res?.data?.paymentParameters;
        this.orderNumber = res?.data?.orderNumber;
        this.publishableKey = res?.data?.publicSecretKey
        localStorage.setItem("orderNumber", this.orderNumber);
        localStorage.setItem("publishableKey", this.publishableKey);
        this.stripe =  await loadStripe(this.publishableKey, {
          locale: this.$i18n.locale == "cn" ? "zh" : this.$i18n.locale, // 绑定当前语言
        });
        if(this.stripe){
          this.init();
        }
      });
    },
    getTime(val) {
      const list = {
        30: this.$t('basePage.month1'),
        180: this.$t('basePage.month2'),
        360: this.$t('basePage.month3'),
      };
      return list[val];
    },
    getGoodsNet() {
      const params = {
        product_types: "base",
      };
      getGoods(params).then((res) => {
        if(!res) return
        if (res?.data?.lists && res?.data?.lists.length != 0) {
          this.list = res?.data?.lists;
        }else {
          this.show = true
          this.message = this.$t("basePage.error1")
          setTimeout(() => {
            this.show = false;
          }, 1000);
        }
      });
    },
    async init() {
      const clientSecret = this.clientSecret;
      const elements = this.stripe.elements({ clientSecret });
      this.elements = elements;
      const options = {
        layout: {
          type: "accordion", // accordion tabs
          defaultCollapsed: true,
          radios: false,
          spacedAccordionItems: true,
        },
      };
      const paymentElement = elements.create("payment", options);
      paymentElement.mount("#payment-element");
      // const linkAuthenticationElement = elements.create("linkAuthentication");
      // linkAuthenticationElement.mount("#link-authentication-element");
      this.isLoading = false;
    },
    async handleSubmit() {
      localStorage.setItem('resultTitle','基础服务')
      if (this.isLoading) return;
      this.isLoading = true;
      this.show = true
      
      this.message = this.$t("OffLineResult.loading")
      const { error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: `${window.location.origin}/OffLineResult`,
        },
      });
      if (error.type === "card_error" || error.type === "validation_error") {
        this.messages.push(error.message);
        this.$message.error(error.message)
        this.show = false
      } else {
        this.messages.push("An unexpected error occured.");
        this.$message.error("An unexpected error occured.")
        this.show = false
      }
      this.isLoading = false;
    },
    getStyle() {
      if (this.lang == "cn" || this.lang == "tw") {
        this.height1 = "88px";
      }
      if (this.lang == "en" || this.lang == "ja") {
        this.height1 = "98px";
      }
      if (this.lang == "ru") {
        this.height1 = "116px";
        this.marginTop = "54px";
      }
      if (this.lang == "es") {
        this.height1 = "120px";
        this.marginTop = "54px";
      }
      if (this.lang == "fr" || this.lang == "de") {
        this.height1 = "106px";
      }
      const list = ["pt", "it", "tr", "vi", "id", "hi", "ar", "th"];
      if (list.includes(this.lang)) {
        this.height1 = "102px";
      }
    },
    handleConfirm() {
      const result=this.list.some(item=>item.checked)
      console.log(result);
      if(!result){
        this.show = true
        this.message = this.$t("basePage.message1")
        return
      }else{
        this.show = false
      }
      if(!this.productId){
        this.show = true
        this.message = this.$t("basePage.error1")
        setTimeout(() => {
          this.show = false;
        }, 1000);
        return;
      }
      this.drawer = true;
      this.getOrderNet();
      // this.init()
    },
    
    goBack() {
      this.$router.push({
        path: "/RedemptionPage",
      });
    },
    handleClose(done) {
      this.show = false
      done();
    },
    handleCheck(val) {
      this.list.forEach((item) => {
        if (item.productId === val.productId) {
          item.checked = true;
          this.amount = item.price;
          this.productId = val.productId
          if (item.discount == "100.00%") {
            item.showDisCount = false;
          } else {
            item.showDisCount = true;
          }
        } else {
          item.checked = false;
        }
      });
      this.$forceUpdate();
    },
  },
};
</script>
  
  <style scoped>
#app {
  height: 100vh;
  text-align: left;
  overflow: auto;
  padding:0px 16px
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}

.fanyi-service {
  width: 100%;
  height: 88px;
  border-radius: 16px;
  background: #ffe6e1;
  margin-top: 16px;
}
.fanyi-service-left {
  float: left;
}
.item1 {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding: 16px 16px 8px 16px;
}
.offline-img {
  width: 32px;
  height: 32px;
  padding-right: 8px;
  vertical-align: middle;
}
.item2 {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  padding-left: 16px;
  max-width: 238px;
}
.item3 {
  width: 80px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  margin: 16px 0px 0px 16px;

  padding-left: 12px;
  cursor: pointer;

  font-family: Montserrat;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.right-img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.fanyi-service-right {
  float: right;
  margin-right: 16px;
}
.icon-right-img {
  width: 16px;
  height: 16px;
}
.right-item1 {
  margin: 22px 0px 32px 32px;
  cursor: pointer;
}
.scan-img {
  width: 50px;
  height: 50px;
  margin-top: 25px;
}
.describe {
  height: 160px;
  border-radius: 16px;
  /* color-white */
  background: #ffffff;
  margin: 16px 0px;
  overflow-x: hidden;
  overflow-y: auto;
}
.describe-title {
  /* display: flex; */
  height: 52px;
  line-height: 52px;
  padding: 0px 16px;
}
.describe-title-left {
  float: left;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.describe-title-right {
  float: right;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.line {
  width: calc(100% - 32px);
  height: 1px;
  /* 2-底色 */
  border-top: 1px solid #f7f7f7;
  margin: 0px auto 16px;
}
.subscribe {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin-left: 16px;
  padding-top: 16px;
}
.subscribe-content {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
  margin: 16px;
  padding-bottom: 16px;
}
.count {
  height: 46px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.count-left {
  float: left;
}
.count-right {
  float: right;
  display: flex;
}
.count-number {
  min-width: 40px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.pay-type-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin: 16px 0px;
}
.line1 {
  width: 100%;
  height: 0px;
  border-top: 1px solid #ebe9e9;
}
.pay-type-content {
  min-width: 120px;
  min-height: 68px;
  border-radius: 8px;
  /* color-white */
  background: #ffffff;
  box-sizing: border-box;
  /* 2-辅色 */
  /* border: 1px solid #201f34; */
  padding: 16px;
  margin-right: 16px;
}
.pay-type-active {
  border: 1px solid #201f34;
}
.pay-type-img {
  width: 20px;
  height: 20px;
}
.pay-type-img1 {
  width: 22px;
  height: 22px;
}
.pay-type-name {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.pay-type {
  display: flex;
  overflow: auto;
  min-height: 70px;
}
.pay {
  margin-top: 16px;
}

.el-button:focus,
.el-button:hover {
  background: #201f34;
  color: #fff;
}

.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  z-index: 9999;
}
.tip {
  min-width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 16px 20px;
}
.drawer >>> .el-drawer.btt {
  border-radius: 16px 16px 0px 0px;
  background: #f6f8fa;
  padding: 0px 16px 90px 16px;
}
.drawer >>> .el-drawer__header {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.product-list {
  position: relative;
  height: 62px;
  line-height: 62px;
  border-radius: 16px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e1e1e1;
  margin-top: 16px;
}
.product-left {
  float: left;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  padding-left: 16px;
}
.product-right {
  float: right;
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 500;
  text-align: right;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  /* ¥ */
  font-family: Montserrat;
  font-weight: 500;
  font-size: 12px;
  font-variation-settings: "opsz" auto;

  /* 19 */
  font-family: Montserrat;
  font-weight: 500;
  font-size: 18px;
  font-variation-settings: "opsz" auto;
  padding-right: 16px;
}
.product-tip {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.isChecked {
  border: 2px solid #201f34;
}
.sale {
  min-width: 57px;
  position: absolute;
  top: -2px;
  left: -2px;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: normal;
  /* color-white */
  color: #ffffff;
  border-radius: 8px 8px 8px 0px;
  /* 功能色板/Error/colorError */
  background: #ff4d4f;
  padding: 0px 5px;
}
.checked-img {
  width: 31px;
  height: 19px;
  border-radius: 4px 0px 16px 0px;
  /* 2-辅色 */
  background: #201f34;
  position: absolute;
  bottom: -2px;
  right: -2px;
}
.drawer-item {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-bottom: 8px;
}
.drawer-input {
  margin-bottom: 16px;
  border-radius: 8px;
  /* color-white */
  background: #ffffff;
}
.drawer-input >>> .el-input__inner {
  border: none;
}
.pay-button {
  width: calc(100% - 32px);
  position: fixed;
  bottom: 24px;
  min-width: 343px;
  height: 44px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  color: #fff;
  /* margin: 24px 0px; */
}
::v-deep .el-drawer__body{
  overflow-x:hidden;
  overflow-y:auto;
}
</style>
  